import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { FormattedMessage, injectIntl } from "react-intl";
import moment from "moment";
import { ButtonComponent } from "../../../components/Controls/Button/Button";
import * as actions from "../../../store/appointments/actions";
import { avatar, men1, men2, men3, women1, women2, women3, checkIcon } from "../../../utils/images";
import TableGridView from "../../../components/TableGridView";
import Filterform from "./Filterform";
import "./style.scss";
import ClippedElement from "../../../components/CLippedElement";
import ConfirmDialog from "../../../components/ConfirmDialog/ConfirmDialog";

const NewAppointments = ({ intl: { messages } }) => {
  const history = useHistory();
  const [searchValues, setSearchValues] = useState({});
  const dispatch = useDispatch();
  const { myAppointments, appointmentsStatistics } = useSelector((state) => state.appointments);
  const [finishConfirmation, setFinishConfirmation] = useState(false);
  const mens = [men1, men2, men3];
  const womens = [women1, women2, women3];

  useEffect(() => {
    //rejected requests list
    dispatch(
      actions?.getMyAppointmentsRequest({
        page: 1,
        appointmentStatus: 1,
        sort: "id,desc",
      })
    );
    dispatch(actions?.getAppointmentsStatisticsRequest());
    return () => {
      dispatch(actions.getMyAppointmentsReceive([]));
    };
  }, [dispatch]);

  //table n grid view render
  const headings = [
    messages.appointments.patient_name,
    messages.appointments.appointment_date,
    messages.appointments.appointment_status,
    messages.appointments.appointment_type,
    messages.appointments.actions,
  ];

  const renderTableData = () => {
    return myAppointments?.data?.map((app, i) => {
      const { patient_name, start_date, purpose_name, type_name } =
        app;
      return [
        patient_name ? (
          <ClippedElement tooltipTitle={patient_name} >
            <span>{patient_name}</span>
          </ClippedElement>
        ) : (
          "-"
        ),
        start_date
          ? moment(start_date).format("DD[.]MM[.]YYYY  ,  HH:mm:ss")
          : "-",
        purpose_name ? purpose_name : "-",
        type_name ? type_name : "-",
        <ButtonComponent
          content={messages.appointments.btn}
          type="button"
          classes={`cyan-button px-8`}
          handleClick={() => {
            history.push(`/appointment/${app.id}`);
          }}
        />,
      ];
    });
  };
  const handlePageChange = (e, page) => {
    return dispatch(
      actions?.getMyAppointmentsRequest({
        page,
        appointmentStatus: 1,
        sort: "id,desc",
        ...searchValues,
      })
    );
  };
  const onImgError = (e, x) => {
    e.target.src = avatar;
  };
  const renderGridView = () => {
    if (myAppointments?.data?.length > 0) {
      return myAppointments?.data?.map((app, ind) => {
        const {
          patient_name,
          start_date,
          purpose,
          patient_image,
          patient_gender_type,
          purpose_name,
          program_name,
        } = app;
        return (
          <div className="col-md-4" key={ind}>
            <div className=" grid-col">
              <div className={`grid-col-img status${purpose || 0}`}>
                {patient_image ? (
                  <img
                    src={patient_image}
                    alt="patient img"
                    onError={(e) => onImgError(e)}
                  />
                ) : (
                  <img src={patient_gender_type 
                    ? patient_gender_type === 1 ? mens[Math.floor(Math.random() * mens.length)] : patient_gender_type === 2 ? womens[Math.floor(Math.random() * womens.length)] : avatar
                    : avatar} alt="avatar img" />
                )}
                <span className="status-label">{purpose_name}</span>
              </div>
              <p className="patient_name">{patient_name}</p>
              <div className="d-flex justify-content-center">
                <p className="mx-3">{program_name}</p>
                <p className="">
                {messages.requests.date}: {moment(start_date).format("DD[.]MM[.]YYYY")}
              </p>
                {/* <p className="mx-3">{request_status}</p> */}
              </div>

              <ButtonComponent
                content={messages.appointments.btn}
                type="button"
                classes={`cyan-button px-8`}
                handleClick={() => {
                  history.push(`/appointment/${app.id}`);
                }}
              />
            </div>
          </div>
        );
      });
    } else {
      return <div className="grid_no_data">{messages.noData.no_data}</div>
    }
  };
  
  return (
    <>
      {myAppointments ? (
        <TableGridView
          title={
            <>
              <FormattedMessage
                values={{
                  total: myAppointments?.total,
                  totals: appointmentsStatistics?.new,
                }}
                id="appointments.app_of"
                defaultMessage={messages.appointments.app_of}
              />
            </>
          }
          Form={<Filterform setSearchValues={setSearchValues} />}
          table={{
            stickyHeader: true,
            headings: headings,
            data: renderTableData(),
            headClass: "bg-white table-head",
            noData: messages.noData.no_data,
          }}
          gridView={renderGridView}
          defaultView="grid"
          pagination={{
            count: myAppointments.last_page,
            page: myAppointments.current_page,
            handleChange: handlePageChange,
          }}
        />
      ) : null}
      <ConfirmDialog show={finishConfirmation} 
                     onCancel={() => {
                        setFinishConfirmation(false)
                      }}
                     onConfirm={() => {
                        setFinishConfirmation(false);
                        history.push("/newRequests");
                     }}
                     icon={checkIcon}
                     content={messages.requests.request_confirmation}
                     cancelBtn={messages.requests.request_confirmation_close}
                     confirmBtn={messages.requests.request_confirmed} />
    </>
  );
};
export default injectIntl(NewAppointments);
